import ComingSoon from "components/ComingSoon";
import React from "react";

const SendGrid = () => {
  return <ComingSoon />;
};

export default SendGrid;
